import React from "react";
import { PageHero, SectionHeader } from "../../components/public/Section";
import { Target, Eye } from "lucide-react";

export default function MissionVision() {
  return (
    <div>
      <PageHero title="Mission & Vision" breadcrumbs={["Home", "About", "Mission & Vision"]} />
      <section className="section container-page grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="card-elev p-10">
          <Target className="text-brand-primary" size={28} />
          <h2 className="font-serif text-3xl font-bold mt-4">Mission</h2>
          <p className="text-brand-muted mt-4 leading-relaxed">To promote excellence in ophthalmology through continuing medical education, scientific research, ethical practice, and dedicated community service across Ghaziabad and the wider NCR region.</p>
        </div>
        <div className="card-elev p-10">
          <Eye className="text-brand-primary" size={28} />
          <h2 className="font-serif text-3xl font-bold mt-4">Vision</h2>
          <p className="text-brand-muted mt-4 leading-relaxed">A future where every citizen enjoys access to world-class, evidence-based eye care delivered by highly trained ophthalmologists who are supported by a vibrant, collaborative professional community.</p>
        </div>
      </section>
    </div>
  );
}
